export default __webpack_public_path__ + "1778f119f5c5e8ad0679148fa733f253.png";